<style lang="less">
.Account_result{
	.icon{
		width: 100%;
		padding: 70px 0 16px 0;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		flex-direction: column;
		img{
			width: 58px;
			height: 58px;
		}
	}
	.title{
		text-align: center;
	}
	.info{
		padding: 30px 22px 0;
		color: #999;
		.item{
			height: 30px;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			padding: 0px 6px 0;
			font-size: 12px;
			label{
				flex: 1;
			}
			&:first-child{
				border-top: 1px solid #e5e5e5;
				padding-top: 8px;
			}
		}
	}
	.jump{
		position: fixed;
		bottom: 72px;
		left: 0;
		width: 100%;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		p{
			color: #DC2A2A;
			font-weight: 700;
		}
	}
	.amt{
		width: 100%;
		text-align: center;
		color: #999;
		font-size: 14px;
		padding-top: 6px;
		font-weight: 400;
	}
	.charge{
		display: -webkit-box; display:flex;
		flex-direction: column;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		padding: 50px 0;
		position: relative;
		background: url(../assets/acc_result.png)  no-repeat 76px center /8px auto;
		.item{
			width: 190px;
			height: 24px;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			font-size: 14px;
			label{
				color: #dc2a2a;
				font-weight: 500;
				padding: 0 6px;
			}
			p{
				color: #999;
			}
		}
	}
	.takeout{
		padding-top: 22px;
		text-align: center;
		font-weight: 400;
	}
}
</style>

<template>
	<!-- Main Account_result -->
	<section class="Account_result">
		<div class="icon" v-if="detail.pay_status !== ''">
			<!-- <img src="../assets/success.png" v-if="detail.pay_status == 1">
			<template v-else>
				<img src="../assets/error.png"  v-if="detail.pay_status == 2">
				<img src="../assets/warn.png" v-else>
			</template> -->
			<img src="../assets/error.png" v-if="detail.pay_status == 2">
			<img src="../assets/success.png" v-else>
		</div>
		<!-- <h3 class="title" v-if="detail.pay_status == 1">{{config.order_type[detail.order_type]}}{{pay_status[detail.pay_status]}}</h3>
		<h3 class="title" v-else>{{detail.pay_status_remark}}</h3> -->
		<h3 class="title" v-if="detail.pay_status == 2">{{config.order_type[detail.order_type]}}失败</h3>
		<h3 class="title" v-else>
			<template v-if="detail.order_type == 10">
				{{config.order_type[detail.order_type]}}成功
			</template>
			<template v-else>
				<template v-if="detail.pay_result_info.redeem_type == 't_0'">
					{{config.order_type[detail.order_type]}}成功
				</template>
				<template v-else>
					提交成功
				</template>
			</template>
		</h3>
		<p class="amt" v-if="detail.pay_status == 2">{{detail.pay_status_remark}}</p>
		<p class="amt" v-else>{{detail.pay_result_info.amt.Format()}} 元</p>

		<template v-if="type.isAcctplus">
			<div class="charge" v-if="detail.pay_status == 1 && detail.pay_result_info.rec_value_date">
				<div class="item">
					<label>{{new Date(detail.pay_result_info.value_date).Format("MM 月 dd 日")}}</label>
					<p>开始计算收益</p>
				</div>
				<div class="item">
					<label>{{new Date(detail.pay_result_info.rec_value_date).Format("MM 月 dd 日")}}</label>
					<p>第一笔收益到账</p>
				</div>
			</div>

			<div class="takeout" v-if="detail.pay_status !== 2 && detail.pay_result_info.pred_cash_time">
				<template v-if="detail.pay_result_info.redeem_type == 't_0'">预计 2 小时内到账</template>
				<template v-else>预计 {{new Date(detail.pay_result_info.pred_cash_time).Format("MM 月 dd 日")}}到账</template>
			</div>
		</template>


		<template v-if="isCodePay">
			<div class="jump">
				<p @click="jump">暂不设置</p>
			</div>
		</template>

		<footbtn :btn-txt="nexText" :is-on="true" v-on:next="next"></footbtn>

	</section>
</template>

<script>
	/*
		global Finish
		global track
	*/

	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';
	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				isCodePay: false,
				config: config,
				detail: {
					pay_status: '',
					pay_result_info: {
						bank_name: '',
						pred_cash_date: ''
					}
				},
				pay_status: config.pay_status,
				type: {
					isAcctplus: false,
					isCharge: false,
				}
			};
		},
		computed: {
			nexText: function () {
				return this.isCodePay ? '设置支付密码' : '完成';
			}
		},
		components: {
			footbtn
		},
		created: function () {
			android('hideLoadingDialog');
			this.getDetail();
			this.type.isAcctplus = this.$route.query.isAccount ? false : true;
			this.isCodePay = this.$route.query.isCodePay ;
		},
		mounted: function () {
			android('addBackPressedListener', {}, this.jump);
			android('addBackPressedListener', {}, this.jump);
		},
		methods: {
			getDetail: function () {
				let _this = this;
				// android('showLoadingDialog', {
				// 	mes: '正在加载'
				// });
				let url = this.type.isAcctplus ? apis.acctplus_order_query : apis.acct_order_query;
				axios.post(url, {
					pay_order_id: _this.$route.query.pay_order_id,
				}).then(function(d) {
					console.log(_this.type.isAcctplus ? 'acctplus_order_query' : 'acct_order_query', d, d.value.pay_result_info);
					android('hideLoadingDialog');
					if (d.code != 200) {
						_this.tips = d.message;
					}else{
						_this.detail = d.value;
						_this.setTitle();
						if (d.value.pay_status == 1) {
							track('event_order_pay_success');
						} else {
							track('event_order_pay_faild');
						}
					}
				});
			},
			setTitle: function () {
				let title = '';
				if (this.detail.pay_result_info.rec_value_date || this.detail.pay_result_info.cash_time) {
					title = "支付结果";
				} else {
					title = "取出结果";
				}
				android('setTitle', {
					title: title
				});
			},
			jump: function () {
				console.log('jump');
				Finish('Account_result');
				// android('finishModule', {
				// 	result: true,
				// 	data:{
				// 		pages: 'Account_result'
				// 	}
				// });
			},
			next: function () {
				if (this.isCodePay) {
					let url = "https://jr-res.meizu.com/resources/jr/paypwd/index.html#/todo?actionType=firstSet";
					let _this = this;
					android('startPageWithCallback', {
						url: url,
						start_type:1,
						data:'',
						display:{
							title:'支付密码'
						}
					}, function () {
						_this.jump();
						// console.log('设置支付密码结果');
					});
				}else{
					this.jump();
				}
			},
			checkPayPwd: function () {
				// let url = 'https://jrpay.meizu.com/oauth/paypwd?version=1.0';
				// user_id
				// /oauth/paypwd/get_status
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Account_result.vue